/**
 * Performance Analytics Service
 * ==============================
 * Client for fetching Performance Analytics data (pattern recognition, edge metrics).
 */

import { getApiUrl } from '../api/config';

const getBaseUrl = () => `${getApiUrl()}/performance`;

/**
 * Fetch Performance Analytics data (pattern recognition, edge metrics).
 * @param {boolean} refresh - If true, forces recomputation. Default false.
 */
export async function getPerformanceAnalytics(refresh = false) {
  const token = localStorage.getItem('access_token');
  if (!token) throw new Error('Not authenticated');

  const response = await fetch(`${getBaseUrl()}/analytics`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ refresh }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Failed to fetch Performance Analytics: ${response.status}`);
  }

  return response.json();
}
